import apiClient from "@/lib/api/api-client";
import { env } from "@/config/env";

export type PortalUserStatus = "pending" | "active" | "verified";

export type ExpectedDailyVolume =
  | "under_1k"
  | "1k_10k"
  | "10k_100k"
  | "100k_plus";

export interface PortalUser {
  id: string;
  contact_name: string;
  email: string;
  terms_accepted_at: string;
  status: PortalUserStatus;
  created_at: string;
  updated_at: string;
  company_name?: string;
  intended_use_case?: string;
  expected_daily_volume?: ExpectedDailyVolume;
}

export interface LoginUserRequest {
  email: string;
  password: string;
}

export interface LoginUserResponse {
  access_token: string;
  token_type: string;
  expires_in: number;
  user: PortalUser;
}

export async function loginUser(payload: LoginUserRequest) {
  const { data } = await apiClient.post<LoginUserResponse>(
    env.authLoginPath,
    payload,
  );
  return data;
}
